








import {Vue, Component, Prop, Emit, Watch} from 'vue-property-decorator'
import {formatDateTime} from "@/utils/formatters";

@Component({})
export default class VisitedStores extends Vue {
  @Prop() params!: { userId: null, date: null };

  visitedStores = [];

  columns = [];
  tableOptions = {
    pagination: true,
    onClickRow: row => this.onClickRow(row)
  };

  async created() {
    this.columns = [
      {field: 'date', title: this.$i18n.t('datum'), formatter: formatDateTime},
      {field: 'storeName', title: this.$i18n.t('objekat')},
      {field: 'city', title: this.$i18n.t('mesto')},
      {field: 'hasLocation', formatter: value => value ? "<i class='fa fa-globe'></i>" : ""},
    ];
  }

  @Watch('params', {deep: true}) async onParamsChange(val) {
    let table = $('#poseteTable');
    if (this.params.date && this.params.userId) {
      this.visitedStores = [];
      table.bootstrapTable('showLoading');
      await this.axios.get(`api/GetVisitedStoresByUserAndDate?date=${this.params.date}&userId=${this.params.userId}`).then(result => {
        this.visitedStores = result.data;
      }).catch(err => {
        table.bootstrapTable('hideLoading');
      }).finally(() => {
        table.bootstrapTable('hideLoading');
      });
    }
  }

  onClickRow(row) {
    this.emitOnClickRow({storeID: row.storeId});
  }

  @Emit('onClickVisitedStoreRow') emitOnClickRow({storeID}) {
  }

}
